// @flow
/* eslint-disable max-classes-per-file */
import Enum from '@rover/shared/js/types/Enum';

export class PopoverPlacement extends Enum<string> {
  static TOP = new PopoverPlacement('top');

  static BOTTOM = new PopoverPlacement('bottom');

  static LEFT = new PopoverPlacement('left');

  static RIGHT = new PopoverPlacement('right');

  static isLocked = true;
}

export class PopoverEvent extends Enum<string> {
  static HOVER = new PopoverEvent('hover');

  static CLICK = new PopoverEvent('click');

  static NONE = new PopoverEvent('none');

  static isLocked = true;
}



// WEBPACK FOOTER //
// ../react-lib/src/components/callouts/Popover/popover.constants.js